export default [
    {
        routeName: 'atts.gallery',
        items: [],
    },
];
